export const MULTIPLIE_PERCENT = 1.5;
